// extracted by mini-css-extract-plugin
module.exports = {"lightContainer":"LrvPagination_lightContainer__2il-Z","darkContainer":"LrvPagination_darkContainer__38J5N"};